import React, { useContext } from "react";
import { Navigate,  } from "react-router-dom";
import {GlobalContext} from "contexts/GlobalContext";
import {ROUTES_PATH} from "routes";
import { getDataFromLocalStorage } from "helpers/generalHelper";
import { GEEKS_USER } from "constants/profile";

const AuthRoute = ({ children }) => {
  const { globalState: {isUserLoggedIn} } = useContext(GlobalContext);
  const geeksUserToken = getDataFromLocalStorage(GEEKS_USER)?.token

 

  return (isUserLoggedIn && geeksUserToken && ROUTES_PATH.SIGN_IN.index) ? (
    children
  ) : (
    <Navigate to={ROUTES_PATH.SIGN_IN.index} replace />
  );
};

export default AuthRoute;
